import { css } from "@emotion/react";

export const slideItem = css`
  flex: 0 0 auto;
  min-width: 0;
  max-width: 100%;
`;
